/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateDeviceAttributeDto,
  DeviceAttributesControllerCreateAttributeV1201,
  DeviceAttributesControllerCreateAttributeV1PathParameters,
  DeviceAttributesControllerDeleteAttributeV1PathParameters,
  DeviceAttributesControllerGetAttributesV1200AllOf,
  DeviceAttributesControllerGetAttributesV1PathParameters,
  DeviceAttributesControllerUpdateAttributeV1200,
  DeviceAttributesControllerUpdateAttributeV1PathParameters,
  UpdateDeviceAttributeDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceAttributesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all standard device attributes
   */

  getAttributes<TData = DeviceAttributesControllerGetAttributesV1200AllOf>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: DeviceAttributesControllerGetAttributesV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-attributes`);
  }
  /**
   * @summary Create a new standard device attribute
   */

  createAttribute<TData = DeviceAttributesControllerCreateAttributeV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DeviceAttributesControllerCreateAttributeV1PathParameters,
    createDeviceAttributeDto: CreateDeviceAttributeDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/device-attributes`, createDeviceAttributeDto);
  }
  /**
   * @summary Update a standard device attribute
   */

  updateAttribute<TData = DeviceAttributesControllerUpdateAttributeV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: DeviceAttributesControllerUpdateAttributeV1PathParameters,
    updateDeviceAttributeDto: UpdateDeviceAttributeDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/device-attributes/${id}`, updateDeviceAttributeDto);
  }
  /**
   * @summary Delete a device attribute
   */

  deleteAttribute<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: DeviceAttributesControllerDeleteAttributeV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/device-attributes/${id}`);
  }
}
